import { Box, Center, Heading, Link, Text } from "@chakra-ui/react";

const footerLinkStyles = {
  fontSize: "xs",
  display: "block",
  my: "0.25em",
  _hover: { textDecoration: "none" },
};

function Footer() {
  return (
    <Box as="footer" pt="4em" pb="2em">
      <Center gap="8em" w="full" alignItems="top">
        <Box>
          <Heading size="sm" mb="0.5em">
            Contacts
          </Heading>

          <Link href="mailto:help@btfdca.finance" isExternal sx={footerLinkStyles}>
            📧 Email
          </Link>

          <Link href="https://twitter.com/btfdca_finance" isExternal sx={footerLinkStyles}>
            🐦 Twitz
          </Link>

          <Link href="https://discord.gg/AcgfRqukQt" isExternal sx={footerLinkStyles}>
            🤿 Discord
          </Link>
        </Box>

        <Box>
          <Heading size="sm" mb="0.5em">
            Unrelated
          </Heading>

          <Link href="https://banner-nfts.com" isExternal sx={footerLinkStyles} _hover={{ textDecoration: "none" }}>
            ✌️ Mint my NFT
          </Link>
        </Box>
      </Center>

      <Center mt="2em">
        <Text fontSize="xs">Copyright © Since 2023 by BTFDCA</Text>
      </Center>
    </Box>
  );
}

export default Footer;
